<template>
    <div>
      <Pos_bill_sale/>
    </div>
  </template>
  
  <script>
  import Pos_bill_sale from "@/components/adminArin/pos_system/pos/Pos_bill_sale";
  export default {
    name: "PosBillSale",
    components: {
      Pos_bill_sale
    }
  }
  </script>
  
  <style scoped>
  
  </style>
  